import styled from 'styled-components';
import {
  getSpace,
  getGridSpans,
  px2rem,
  mq,
  getGridSpan,
  maxContentWidth
} from '../../../stylesheets/tools';

const StyledAuthor = styled.section`
  margin: 0 auto;
  width: 100%;
  ${maxContentWidth()}

  .author__wrapper {
    position: relative;
    margin: 0 ${px2rem('26px')};

    ${mq('m')} {
      margin: 0 ${px2rem('46px')};
    }
  }

  .author {
    ${getGridSpans('width', { s: 12, m: 7 })}
    ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'] })};

    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    border-top: 3px solid #000;
    padding: ${getSpace('l')} 0;
    flex-direction: column-reverse;
    margin: ${getSpace('xl')} 0;

    ${mq('xl')} {
      flex-direction: row;
    }
  }

  .author__image {
    align-self: flex-end;
    margin-bottom: 10px;
    margin-right: ${getGridSpan(1, 'spread')};
    margin-top: -${getSpace('xxl')};
    overflow: hidden;
    position: relative;

    &:before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 15px;
      height: 21px;
      background: #fff;
      transform: rotate(45deg);
      transform-origin: top right;
    }

    img {
      width: 100%;
      max-width: ${px2rem('150px')};
      height: auto;
      border-radius: 6px;
    }

    ${mq('xl')} {
      margin-bottom: 0;
      margin-right: 0;
      margin-top: ${getSpace('l')};
    }
  }

  .author__content {
    flex-grow: 2;
    ${getGridSpans('margin-left', { s: [1, 'spread'], m: [1, 'spread', 7] })};
    margin-top: -2px;
  }

  .author__name {
    margin-top: 5px;
  }

  .author__contact {
    display: inline-flex;
    align-items: center;
    margin: ${getSpace('xs')} 0;
    margin-right: ${getSpace('m')};

    ${mq('m')} {
      display: flex;
      margin-right: 0;
    }

    & > span {
      padding-bottom: 2px;
      border-bottom: 1px solid #000;
      display: none;

      ${mq('m')} {
        display: block;
      }
    }

    svg {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
`;

export default StyledAuthor;
